import { createContext } from 'react'

import { NYLAS_REDIRECT, NylasRedirect } from '../../../../lib/constants'

const NylasRedirectContext = createContext<NylasRedirect>(
  NYLAS_REDIRECT.emailAndCalendarIntegration,
)

export default NylasRedirectContext
